/**
 * mergeGuestData.js
 * Service gọi backend merge-guest endpoints sau khi user login.
 * Backend đã có sẵn 2 endpoints (Phase 07 + 08 BE):
 *   POST /wp-json/custom-favorites/v1/merge-guest
 *   POST /wp-json/custom-cart/v1/merge-guest
 */
import request from "../../config/axios";

/**
 * Merge guest cart vào account cart sau login.
 *
 * @param {Array} guestItems - Mảng cart items từ guest storage
 * @returns {Promise<{ merged: number[], invalid: any[], out_of_stock: any[], cart: object }>}
 */
export const mergeGuestCart = async (guestItems) => {
  if (!guestItems || guestItems.length === 0) {
    return { merged: [], invalid: [], out_of_stock: [], cart: {} };
  }

  const items = guestItems.map((item) => ({
    product_id: item.product_id || item.id,
    quantity: item.quantity || 1,
    ...(item.variation_id && { variation_id: item.variation_id }),
    ...(item.attributes &&
      Object.keys(item.attributes).length > 0 && {
        attributes: item.attributes,
      }),
  }));

  const response = await request.post(
    "/wp-json/custom-cart/v1/merge-guest",
    { items },
    { withCredentials: true }
  );

  return response;
};

/**
 * Merge guest wishlist vào account wishlist sau login.
 *
 * @param {Array<number>} productIds - Mảng product IDs từ guest storage
 * @returns {Promise<{ added: number[], already_exists: number[], invalid: number[] }>}
 */
export const mergeGuestWishlist = async (productIds) => {
  if (!productIds || productIds.length === 0) {
    return { added: [], already_exists: [], invalid: [] };
  }

  const response = await request.post(
    "/wp-json/custom-favorites/v1/merge-guest",
    { product_ids: productIds },
    { withCredentials: true }
  );

  return response;
};
